import { lazy } from "react";
const BillResult = lazy(() => import("app/pages/cb/billDetail/BillResult"));

export const cbRouter: any = [
  { path: "/bill/result", element: <BillResult /> },
];
